
<t-row class="permissions-table-row">
  <t-column size="" v-tooltip="action.defaultLabelTitle" class="permissions-table-row-header row-header-selector">
    <span class="header-text">{{ action.defaultLabelTitle }}</span>
  </t-column>
  <t-column v-for="permittee in permissionsTablePermittees" :key="`${action.client_id}_${permittee.client_id}`" size="">
    <row>
      <input
          :id="`enable_action_permission_${action.client_id}_${permittee.client_id}`"
          type="checkbox"
          @input="createDestroyPermission(permittee, action, ObjectModelPermissionCapabilityType.Enable)"
          :checked="!!permissionFor(permittee, action, ObjectModelPermissionCapabilityType.Enable)"
          :disabled="disabled(permittee)"
      >
      <label :for="`enable_action_permission_${action.client_id}_${permittee.client_id}`">
        Enable
        <help-tooltip>{{ tooltip(permittee) }}</help-tooltip>
      </label>
    </row>
  </t-column>
  <t-column :class="`empty_cell`" v-for="index in remainingColumns" :key="`empty_cell_${index}`" size=""><row>&nbsp;</row></t-column>
</t-row>
